<template>
	<div>
		<div class="container container--small pdt-50 pdb-50">
				<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('1646')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('1647')}}</div>
				<form @submit.prevent="" novalidate>
				<div class="pdl-24 pdr-24">
					<div class="mgt-40">
						<label
								class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
								data-mdc-auto-init="MDCTextField" 
								:class="submitState && passwordInvalidCheck ? 'mdc-text-field--invalid' : ''"
								id="passwordEl">
								<span class="mdc-notched-outline">
										<span class="mdc-notched-outline__leading"></span>
										<span class="mdc-notched-outline__notch">
														<span class="mdc-floating-label" id="my-label-id">{{$t('1648')}}</span>
										</span>
										<span class="mdc-notched-outline__trailing"></span>
								</span>
								<input class="mdc-text-field__input" type="password"
									v-model="password"
									v-validate="'required|min:8|verify_password'"
									ref="password"
									id="password"
									name="password"
									maxlength="50"
						 		required>
								<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
												role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line">
								<div class="mdc-text-field-helper-text t-helper mdc-text-field-helper-text--validation-msg t-helper font-r"
								:class="submitState && passwordInvalidCheck ? 't-color-textfieldError' : ''"
								 aria-hidden="true">
								 {{$t('1649')}}
								</div>
						</div>
					</div>
					<div class="mgt-30">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="next()" @keypress="next()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('1650')}}</span>
						</button>
						<button class="mdc-button t-color-secondaryBtnText b-radius4 " @click="cancelJoin()" @keypress="cancelJoin()" tabindex="0">
								<div class="mdc-button__ripple"></div>
								<span class="mdc-button__label t-body2 font-r">{{$t('1651')}}</span>
						</button>
					</div>
				</div>
				</form>
		</div>
	</div>
</template>

<script>
/**
 * 회원가입 - 패스워드 입력(sign up - input password component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
	data() {
		return {
			password: '',
			passwordTextField: null,
			submitState: false,
			validIcon: ''
		}
	},

	mixins: [joinMixin],

	computed : {
		...mapState('join',{
			join : state => state,
		}),
	   
		// password 유효성 Check 및 아이콘(validation password & set icon)
		passwordInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('password')) {
					returnValue = true
					this.validIcon = 'warning'
				}else {
					returnValue = false
					this.validIcon = 'check'
				}
			}

			this.passwordTextField.valid === !returnValue ? '' : this.passwordTextField.valid = !returnValue
			return returnValue
		}

	},

	created() {
		if (!this.join.responsibility || !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || !this.join.name.last || !this.join.loginId) {
			this.moveJoin2Intro()
		}

	},

	mounted() {
		this.setMaterialUi()
		this.$refs.password.focus()
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_LOGINPW']),

		setMaterialUi() {
			this.passwordTextField = new MDCTextField(document.querySelector('#passwordEl'))
			this.passwordTextField.useNativeValidation = false
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

			this.password = this.join.loginPw
			this.passwordTextField.value = this.password
		},

		next() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					this.SET_LOGINPW(this.password)
					localStorage.setItem('password',this.password)
					this.$router.push({name: 'Join2RePassword'})
				} else{
					this.focusFirstInvalidElement()
				}
			})
		}
	},
}
</script>
<style scoped>
.mdc-text-field-helper-text.t-helper {
    opacity: 1;
}
</style>